import _ from 'lodash'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, reduxForm } from 'redux-form'
import { Icon, Grid } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { FEATURED } from '../../../constants/filters'
import FeaturedFiltersContent from './content'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const { Row, Column } = Grid

export const BASE_ELM_ID = 'featured_filters'
export const FORM_NAME = 'featuredFilters'

class FeaturedFiltersForm extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    submitForms: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    marketingTagsConfig: PropTypes.array.isRequired,
  }

  submitForms = () => {
    this.props.submitForms(FORM_NAME)
  }

  onClose = () => this.props.onClose(null, { filtername: FEATURED })

  updateFilters = filters => {
    const newFilters = {
      offset: 0,
      marketingTag: Object.values(filters)
        .filter(_.identity)
        .join(',')
        .toLowerCase(),
    }
    this.props.updateFilters(newFilters)
  }

  render() {
    const { handleSubmit, marketingTagsConfig, ...rest } = this.props
    return (
      <Form
        className={cx('ui', 'form', 'extra-compact')}
        data-elm-id={`${BASE_ELM_ID}_form`}
        onSubmit={handleSubmit(this.updateFilters)}
      >
        <Row>
          <Column className={cx('filter-close-button')}>
            <Icon
              data-elm-id={`${BASE_ELM_ID}_close_button`}
              className={cx('u-pointer-cursor')}
              onClick={this.onClose}
              iconStyle='light'
              name='times'
              fitted
            />
          </Column>
        </Row>
        <FeaturedFiltersContent
          {...rest}
          elmId={BASE_ELM_ID}
          className={cx('filter-root', 'overflow-visible')}
          submitForms={this.submitForms}
          marketingTagsConfig={marketingTagsConfig}
        />
      </Form>
    )
  }
}

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(FeaturedFiltersForm)
